import React from 'react'
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

interface PropsModel {
    expanded?: boolean, languages: string[]
}

export default function LanaguagesLogo(props: PropsModel) {
    const theme = useTheme();
    // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
    const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
    const ltmd = useMediaQuery(theme.breakpoints.down("md"));
    const { expanded = false, languages=[] }: PropsModel = props;

    const singleLogoCard = (value: string, key: number) => (
        <Box flex={1} p={0.5} key={key} display={ltsm ? "" :"flex"} justifyContent={ltsm ? "start" : "center"}>
            <Tooltip title={value.toUpperCase()} arrow>
                {expanded ? (
                    <div className={"ui-stacked-item ui-flex--align-items ui-flex--justify-center ui-padding--6 ui-border--r8 " + (ltmd ? 'ui-rect--56' : 'ui-rect--64')}>
                        <img src={"/assets/logo/" + value + ".svg"} className="ui-image" alt={value} />
                    </div>
                ): (
                        <div className={"ui-stacked-item ui-flex--align-items ui-flex--justify-center ui-padding--6 ui-border--r8 " + (ltmd ? 'ui-rect--46' : 'ui-rect--40')}>
                            <img src={"/assets/logo/" + value + ".svg"} className="ui-image" alt={value} />
                        </div>
                )}
            </Tooltip>
        </Box>
    );

    const StackedCard = (value: string, key: number) => (
        <div key={key} className="ui-stacked-cards ui-position--relative ui-width--56 ui-margin--top-4">
            <div className={"ui-stacked-item ui-position--absolute " + (ltmd ? 'ui-rect--46' : 'ui-rect--40')}></div>
            <div className={"ui-stacked-item ui-position--absolute " + (ltmd ? 'ui-rect--46' : 'ui-rect--40')}></div>
            <Tooltip title={languages.length - 3 + " More"} arrow>
            <div className={"ui-flex--justify-center ui-stacked-item ui-position--absolute ui-padding--6 " + (ltmd ? 'ui-rect--46' : 'ui-rect--40')}>
                <img src={"/assets/logo/" + value + ".svg"} className="ui-rect--24 ui-image--blur ui-z-index--0 ui-position--absolute" alt={value} />
                <span className="ui-typo--body2 ui-font-weight--medium">
                    +{languages.length - 3}
                </span>

            </div>
            </Tooltip>
        </div>
    );




    return (
        <Box display="flex" flexDirection="row" flexWrap="wrap">
            {languages.map((value: string, key: number) => {
                return (expanded ? (singleLogoCard(value, key)): (
                    (value && languages.length <= 4) ? (singleLogoCard(value, key)) :
                (languages.length > 4 && key < 3) ? (singleLogoCard(value, key)) :
                    (key === 4) ? (StackedCard(value, key)) : ''
                ))
            })}
        </Box>
    );
}
